import { styled } from '@mui/material/styles';
import { APP_DRAGGABLE_DRAWER_HEIGHT_VAR, MIN_DRAWER_HEIGHT } from './DraggableDrawer.constants';

// A reusable wrapper that reserves bottom space equal to the draggable drawer height.
// It reads from the globally-published CSS variable with a safe fallback.
export const DrawerBottomSpacer = styled('div')(() => ({
  marginBottom: `var(${APP_DRAGGABLE_DRAWER_HEIGHT_VAR}, ${MIN_DRAWER_HEIGHT}px)`,
}));

export default DrawerBottomSpacer;
